$(->
  $('iframe.admin__iframe').on 'load', (e) ->
    return if $(this.contentDocument.body).hasClass('voyager-admin')
    window.location = this.contentDocument.location
  iFrameResize {
      "autoResize": false,
      "onMessage": (data)->
        message = JSON.parse(data.message)
        window.location = message.redirect if message.redirect
    },
   'iframe.admin__iframe'

  handle_info_hover_on = ->
    the_link = $(this)
    link_info_div = $('#info_receiver')
    if link_info_div.length < 1
      $('body').append('<div id="info_receiver" class="collapse"></div>')
      link_info_div = $('#info_receiver')
    the_info_div = $(the_link.data('hover-target'))
    if the_link.data('info-cache')?
      the_info_div.collapse('show').find('.content').html(the_link.data('info-cache'))
    else
      link_info_div.load the_link.data('hover-url'), ->
        the_info_div.collapse('show').find('.content').html(link_info_div.html())
        the_link.data('info-cache', link_info_div.html())
        the_info_div.find('a.account-info-hover')
          .hoverIntent handle_info_hover_on, handle_info_hover_off
  handle_info_hover_off = ->
    unless $(this).closest('.account').find('a.lock-hover').data('enabled')
      $($(this).data('hover-target')).collapse('hide')
  $('a.account-info-hover').hoverIntent handle_info_hover_on, handle_info_hover_off

  $(document).on 'click', 'a.lock-hover', (ev)->
    if $(this).data('enabled')
      $(this).data('enabled', false).html('lock-hover')
    else
      $(this).data('enabled', true).html('locked')
    false

  $(document).on 'click', '#account_list .account .info .close', (ev)->
    $(this).closest('.info').hide()
    false

  $(document).on 'change', '#account_list .account .priority select', (ev)->
    f = $(this).closest('form')
    $.ajax({
      url: f.attr('action'),
      type: "PATCH",
      data: f.serialize()
    })

  bulk_post = (link, sep) ->
    ids = []
    the_link = $(link)
    $('.select_item:checked').each ->
      ids.push($(this).val())
    the_link.attr('href', the_link.attr('href') + "#{sep}ids=" + ids.join(','))

  $('#download_requests').click ->
    bulk_post(this, '?')
  $('#js-bulk-sourced-resume-requests').click ->
    bulk_post(this, '&')
  $('#js-bulk-complete-resume-requests').click ->
    bulk_post(this, '&')

  $(document).on 'change', '#follow_up_only', ->
    if $(this).prop('checked')
      $(this).closest('form').find('.event_fields').hide()
      $(this).closest('form').find('.event_fields input, .event_fields select, .event_fields textarea').prop('disabled',true)
    else
      $(this).closest('form').find('.event_fields').show()
      $(this).closest('form').find('.event_fields input, .event_fields select, .event_fields textarea').prop('disabled',false)

  update_navbar_setting = (val)->
    $.ajax
      url: '/admin/users/' + $('#impersonation-navbar').data('user') + '/update_setting'
      type: 'PATCH',
      data: 'value=' + val + '&name=' + $('#impersonation-navbar').data('name')

  adjustPadding = () ->
    oh = $('#top_navigation_wrapper').outerHeight()
    $('body').css('padding-top', "#{oh}px")
    $('body.impersonating div.uses-scroll-spy div.panel-anchor').css('top', "-#{oh}px")

  $(window).on 'resize', adjustPadding

  $(window).on 'load', () ->
    $(window).trigger 'resize'

  adjustPadding()

  $('#collapse-impersonation-navbar').click ->
    if $('#impersonation-navbar').hasClass('mini')
      update_navbar_setting(0)
      $('#impersonation-navbar').removeClass('mini')
      $('body').removeClass('impersonating-mini')
    else
      update_navbar_setting(1)
      $('#impersonation-navbar').addClass('mini')
      $('body').addClass('impersonating-mini')
    $(window).trigger 'resize'
    false

  $('#impersonation-navbar').data('orig-header-bar-height', $('#header_bar').height())

  if $('#impersonation-navbar').hasClass('mini')
    $('#impersonation-navbar').removeClass('mini')
    $('#collapse-impersonation-navbar').click()

  $('#add_permission_override').click ->
    if $('#permission_override').val().length > 0
      val = $('#permission_override option:selected')
      $('#permission_override_list').append($(this).data('template'))
      new_item = $('#permission_override_list .array_check_boxes').last()
      new_item.find('input').attr('name', 'permissions[' + val.attr('value') + ']')
      new_item.find('label span').text(val.text())
    false

   $(document).on 'click', 'a.remove_permission_override', ->
    item = $(this).closest('.array_check_boxes')
    if $(this).data('name')?
      $.ajax
        url: '/admin/' + $(this).data('type') +
        '/' + $(this).data('account') + '/permission'
        type: 'DELETE',
        data: { name: $(this).data('name') }
    item.remove()
    false

  $('input#permissions_permission_account_account_only_location[type=checkbox]').change ->
    if $(this).is(':checked')
      $('div#account_only_location').removeClass('hidden')
    else
      $('div#account_only_location').addClass('hidden')
      $('div#account_only_location input').val("")

  $(document).on 'change', 'select.followup-type', ->
    the_fs = $(this).closest('fieldset')
    if $(this).val() == ''
      $("#follow_up_details").collapse('hide')
    else
      $("#follow_up_details").collapse('show')
      if parseInt($(this).val()) == 4
        the_fs.find('.log_type_name_input').show()
      else
        the_fs.find('.log_type_name_input').hide()

  $(document).on 'change', '#job_aggregator_subdomain', ->
    $('#embed_subdomain').text($(this).val())

  $('.collapse[data-get]').on 'show.bs.collapse', ->
    return if $(this).data('loaded')?
    $(this).load($(this).data('get'))
    $(this).data('loaded', true)

  # show/hide current password field when email field is edited
  $(document).on 'input', '.current-password-wrapper input#user_email', (e) ->
    return unless $('.current-password').length > 0
    return if $('.current-password-wrapper').hasClass('active')
    $('.current-password').removeClass('hidden')
    $('.current-password-wrapper').addClass('active')
)
